function AuthToken() {}

export const setToken = function (token) {
  // console.log("Tokenized");
  AuthToken.prototype.token = token;
};

export const getToken = () => new AuthToken().token;
